import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { App } from "./app/App";
import { AppProviders } from "./app/providers";
import { registerServiceWorker } from "./app/registerServiceWorker";
import { installClientErrorReporting } from "./shared/telemetry/clientErrors";
import "./styles/index.css";

installClientErrorReporting();

const router = createBrowserRouter([
  { path: "*", element: <AppProviders><App /></AppProviders> }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

registerServiceWorker();
